module.exports = __webpack_public_path__ + "img/weekly-bonus.ce5b1278.png";